export default class AI{
    constructor(heightWeight, linesWeight, holesWeight, bumpinessWeight){
        this.heightWeight = heightWeight;
        this.linesWeight = linesWeight;
        this.holesWeight = holesWeight;
        this.bumpinessWeight = bumpinessWeight;
    }
    _best(grid, workingPieces, workingPieceIndex){
        var best = null;
        var bestScore = null;
        var workingPiece = workingPieces[workingPieceIndex];
    
        for(var rotation = 0; rotation < 4; rotation++){
            var _piece = workingPiece.clone();
            for(var i = 0; i < rotation; i++){
                _piece.rotate(grid);
            }
    
            while(_piece.moveLeft(grid));
            while(grid.valid(_piece)){
                var _pieceSet = _piece.clone();
                while(_pieceSet.moveDown(grid));
    
                var _grid = grid.clone();
                _grid.addPiece(_pieceSet);
    
                var score = null;
                if (workingPieceIndex == (workingPieces.length - 1)) {
                    score = -this.heightWeight * _grid.aggregateHeight() + this.linesWeight * _grid.lines() - this.holesWeight * _grid.holes() - this.bumpinessWeight * _grid.bumpiness();
                }else{
                    score = this._best(_grid, workingPieces, workingPieceIndex + 1).score;
                }
    
                if (score > bestScore || bestScore == null){
                    bestScore = score;
                    best = _pieceSet;//_piece.clone();
                }
    
                _piece.column++;
            }
        }
    
        return {piece:best, score:bestScore};
    }
    _best2(grid, workingPieces, workingPieceIndex){
        var best = null;
        var bestScore = null;
        var workingPiece = workingPieces[workingPieceIndex];
    
        
        for(var rotation = 0; rotation < 4; rotation++){
            var _piece = workingPiece.clone();
            for(var i = 0; i < rotation; i++){
                //if(rotation > 0){
                    _piece.rotate(grid,true);
                //}
            }
            if(workingPiece.id == 0 && rotation > 0){
                this.consolelog("rotation")
            }
            //while(_piece.moveLeft(grid));
            var peace_w = _piece.dimension -1 
            for(var _row = - peace_w ;_row < (grid.cells.length);_row++) {
            for(var _column = - peace_w ;_column < (grid.cells.length + peace_w);_column++) {
            _piece.column = _column
            _piece.row = _row
            if(grid.valid(_piece)){
                var _pieceSet = _piece.clone();
                while(_pieceSet.moveDown(grid));
    
                var _grid = grid.clone();
                _grid.addPiece(_pieceSet);
    
                var score = null;
                if (workingPieceIndex == (workingPieces.length - 1)) {
                    //score = -this.heightWeight * _grid.aggregateHeight() + this.linesWeight * _grid.lines() - this.holesWeight * _grid.holes() - this.bumpinessWeight * _grid.bumpiness();
                    score = - this.holesWeight * _grid.countHoles() + this.heightWeight * _piece.row;
                }else{
                    score = this._best2(_grid, workingPieces, workingPieceIndex + 1).score;
                }
    
                if (score > bestScore || bestScore == null){
                    bestScore = score;
                    best = _pieceSet;//_piece.clone();
                }
              
            }
                //_piece.column++;
                
            }
        }
        }
    
        return {piece:best, score:bestScore};
    }
    best(grid, workingPieces){
        return this._best(grid, workingPieces, 0).piece;
    }
    consolelog(val){
       // console.log(val)
    }
}